import Image from 'next/image';
import { useLocationState } from '../context/location';
import Button from './Button';
import styles from '../styles/modules/Intro.module.scss';

const Intro = ({ title, description, phone, phoneURI, image, alt, button, onClick }) => {
  const locationState = useLocationState();

  return (
    <section className={['block', styles.intro].join(' ')}>
      <div className={['fixed', styles.introContainer].join(' ')}>
        <div className={styles.introText}>
          <h1 className={styles.introTitle}>{title}</h1>
          <div className={styles.introDescription}>{description}</div>
          <Button className={styles.introButton} color="white" onClick={onClick}>
            {button}
          </Button>
          <div className={styles.introCaption}>
            Или свяжитесь по телефону
            <a
              className={styles.introCaptionLink}
              href={phoneURI ? phoneURI : locationState.phoneURI}
            >
              {phone ? phone : locationState.phone}
            </a>
          </div>
          <div className={styles.introPattern}>
            <img src="/images/pattern.svg" alt="" />
          </div>
        </div>
        <div className={styles.introImage}>
          <Image src={image} alt={alt} priority fill />
        </div>
      </div>
    </section>
  );
};

Intro.defaultProps = {
  visibility: true
};

export default Intro;
